import { render, staticRenderFns } from "./Users_formations.vue?vue&type=template&id=58a59597&lang=pug&"
import script from "./Users_formations.vue?vue&type=script&lang=coffee&"
export * from "./Users_formations.vue?vue&type=script&lang=coffee&"
import style0 from "./Users_formations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports